import { TextField } from '@material-ui/core';
import './otp-field.scss';
import en from '../../lang/en-us';
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';
import { NoteModals } from '../NoteModals';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { REGISTER_WITH_MOBILE } from '../../utils/constants';
import { maskMobileNumber } from '../../utils/utilityFunctions';
const { common, dashboard } = en;
const OTP_LENGTH = 6;
export function OtpField({
    value: otp = new Array(6).fill(''),
    disabled = false,
    showModal,
    maskedInfo,
    _handleProceed = () => {},
    formik = {},
    ...props
}: any) {
    const ref = useRef<any>([]);
    const [isPasteData, setIsPasteData] = useState<boolean>(false);
    const { email, mobile, userRegisteredWith } = useSelector(({ authReducer }: RootStateType) => ({
        ...authReducer,
    }));

    useEffect(() => {
        if (ref.current.length) {
            ref.current[0].focus();
        }
    }, []);

    const otpChange = (value: string, index: number) => {
        //handle paste directly
        if(value.length === OTP_LENGTH) {
            const otpVal = value.replace(/\s+/g, ' ').trim();
            if (otpVal.length == 6 && !isNaN(+otpVal)) {
                const otpArr = otpVal.split('');
                props.updateValue(otpArr);
                ref.current[5].focus();
            }
            return;
        }
        if (!/^[\d ]*$/.test(value) || isPasteData) {
            setIsPasteData(false);
            return;
        }
        if ((value && !otp[index].length) || !value) {
            if (!!props.updateValue && typeof props.updateValue === 'function') {
                props.updateValue(
                    otp.map((ele: string, _index: number) => (_index === index ? value : ele)),
                );
            }
            if (index < 5 && value) {
                ref.current[index + 1].focus();
            }
        }
    };


    const handleKeyDown = (index: number) => (event: any) => {
        // let index = otp.filter((ele: string) => !!ele).length;
        if (event.key == 'Backspace' || event.key === 'Delete') {
            if (!otp[index]) {
                if (!(index - 1 < 0)) {
                    props.updateValue(
                        otp.map((ele: string, _index: number) => (_index === index ? '' : ele)),
                    );
                    ref.current[index - 1].focus();
                }
            }
        }
    };

    return (
        <div className="otp-field">
            {/* <h6>{common.otpinput}</h6> */}
            <div className="otp-inputs">
                {otp.map((ele: string, index: number) => (
                    <TextField
                        inputRef={(ele) => (ref.current[index] = ele)}
                        disabled={disabled}
                        focused={ref.current === index}
                        onChange={({ target: { value } }) => otpChange(value, index)}
                        onKeyDown={handleKeyDown(index)}
                        value={ele}
                        key={index}
                        variant="filled"
                        inputProps={{ inputMode: 'numeric' }}
                    />
                ))}
            </div>
            {formik?.touched?.otp && formik?.errors?.otp && (
                <p
                    style={{
                        color: '#f44336',
                        fontSize: '12px',
                        fontFamily: 'Montserrat-Medium',
                        paddingLeft: '10px',
                    }}
                >
                    {formik.errors.otp}
                    {''}
                </p>
            )}
            <NoteModals
                showModal={showModal}
                heading={dashboard.UpdateForm15.pleaseNote}
                info={
                    maskedInfo
                        ? maskedInfo
                        : `Please enter the 6-digit OTP sent to ${
                              userRegisteredWith === REGISTER_WITH_MOBILE
                                  ? maskMobileNumber(mobile)
                                  : `*****@${email?.split('@')[1] || '******@***'}`
                          }`
                }
                proceedBtn={'Okay'}
                onProceed={_handleProceed}
            />
        </div>
    );
}

export function ResendOtp({ startTimer = true, counter = 10, onResendOtp, ...props }: any) {
    const onResend = () => {
        if (!!onResendOtp && typeof onResendOtp === 'function') {
            onResendOtp();
        }
    };

    return (
        <p className="resend_otp">
            {startTimer ? (
                common.resendotp
            ) : (
                <>
                    {common.didntReceiveotp} <a onClick={onResend}>{common.resendtext}</a>
                </>
            )}
            {startTimer ? <span> {counter}s</span> : ''}
        </p>
    );
}

export function useTimer({ initcounter = 60, initStart = true }) {
    const [timer, setTimer] = useState<number>(initcounter);
    const [startTimer, setTimerStart] = useState<boolean>(initStart);
    const interval = useRef<any>(null);

    const resetTimer = useCallback(() => {
        clearInterval(interval.current);
        setTimer(initcounter);
        setTimerStart(initStart);
    }, [initcounter, initStart]);

    const stopTimer = useCallback(() => {
        clearInterval(interval.current);
        setTimerStart(false);
    }, []);

    useEffect(() => {
        if (timer < 1) {
            setTimerStart(false);
            return;
        }
        if (startTimer) {
            interval.current = setInterval(() => setTimer((timer) => timer - 1), 1000);
        }
        return () => clearInterval(interval.current);
    }, [timer, startTimer]);

    return {
        timer,
        startTimer,
        setTimerStart,
        resetTimer,
        stopTimer,
    };
}
